import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "@/api";
import { dict } from "@/i18n";
import { CONTACT_EMAIL, ORDER_MSG_AR, ORDER_MSG_EN, WHATSAPP_DISPLAY, WHATSAPP_NUMBER } from "@/config";

const SiteContext = createContext(null);

export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get(`${API_BASE}/settings`).then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const waNumber = settings.whatsapp_number || WHATSAPP_NUMBER;

  const waLink = (lang) => {
    const msg = lang === "ar" ? ORDER_MSG_AR : ORDER_MSG_EN;
    return `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
  };

  const contact = {
    waNumber,
    waDisplay: settings.whatsapp_display || WHATSAPP_DISPLAY,
    email: settings.email || CONTACT_EMAIL,
    phone: settings.phone || settings.whatsapp_display || WHATSAPP_DISPLAY,
  };

  const img = (key, fallback) => settings[key] || fallback;

  const heroText = (lang) => {
    const base = dict[lang].hero;
    return {
      line1: (lang === "ar" ? settings.hero_ar_line1 : settings.hero_en_line1) || base.h1a,
      line2: (lang === "ar" ? settings.hero_ar_line2 : settings.hero_en_line2) || base.h1b,
      sub: (lang === "ar" ? settings.hero_ar_sub : settings.hero_en_sub) || base.sub,
    };
  };

  return (
    <SiteContext.Provider value={{ settings, setSettings, contact, waLink, img, heroText }}>
      {children}
    </SiteContext.Provider>
  );
}
